import { defineLiveHandler, resourceTag, type LiveHandler } from '@krp/client-runtime'

import { AQSI_DELIVERY_TAG } from './deliveryApi'

/** Тип события службы AQSI: проход доставки каталога завершён (договор с `AqsiLiveEvents`). */
export const AQSI_DELIVERY_CHANGED = 'aqsi.delivery.changed'

/**
 * Доставка каталога в кабинет (LIVE): служба сообщает о каждом проходе,
 * обратившемся к кабинету, — окно «Доставка каталога» перечитывает статус и
 * операции по событию, а не каждые 10 секунд. Редкий страховочный опрос
 * остаётся в окне: событие может потеряться, канал — не источник истины.
 */
export const deliveryLiveHandlers: readonly LiveHandler[] = [
  defineLiveHandler({
    type: AQSI_DELIVERY_CHANGED,
    invalidates: (envelope) =>
      envelope.resourceId === null
        ? []
        : [
            resourceTag(AQSI_DELIVERY_TAG, envelope.resourceId, 'STATUS'),
            resourceTag(AQSI_DELIVERY_TAG, envelope.resourceId, 'OPERATIONS'),
          ],
    resync: [AQSI_DELIVERY_TAG],
  }),
]
